import { Row, Col, Card } from 'react-bootstrap';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import Flex from '@/components/common/Flex';
import IconItem from '@/components/common/icon/IconItem';
import SubtleBadge from '@/components/common/SubtleBadge';
import type { TopicsOverviewSummary } from '../../types';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { getHelpHtml } from '../../utils/help/help-content';

export function TopicSummaryCards({
  summary,
  domainFilterActive = false,
}: {
  summary: TopicsOverviewSummary;
  domainFilterActive?: boolean;
}) {
  const cards: Array<{
    label: string;
    helpKey: string;
    value: string | number;
    sub: string;
    accent: string;
    icon: IconProp;
    color: string;
  }> = [
    {
      label: 'مجموع تاپیک‌ها',
      helpKey: 'total_topics',
      value: summary.totalTopics,
      sub: 'در همه تاپیک‌ها',
      accent: 'text-1000',
      icon: 'folder',
      color: 'primary',
    },
    {
      label: 'مجموع پرامپت‌ها',
      helpKey: 'total_prompts',
      value: summary.totalPrompts,
      sub: 'پرامپت‌های متصل',
      accent: 'text-primary',
      icon: 'list-alt',
      color: 'info',
    },
    {
      label: 'مجموع اجراها',
      helpKey: 'total_executions',
      value: summary.totalExecutions,
      sub: 'اجراهای AI',
      accent: 'text-info',
      icon: 'play',
      color: 'warning',
    },
    {
      label: 'میانگین دیده‌شدن در AI',
      helpKey: 'avg_visibility',
      value: `${summary.averageVisibility}%`,
      sub: domainFilterActive ? 'برای دامنه انتخاب‌شده' : 'در همه تاپیک‌ها',
      accent: 'text-success',
      icon: 'eye',
      color: 'success',
    },
  ];

  return (
    <Row xs={2} xl={4} className="g-3">
      {cards.map(card => (
        <Col key={card.label}>
          <Card className="h-100 shadow-sm">
            <Card.Body className="p-3">
              <Flex justifyContent="between" alignItems="center" className="gap-2">
                <div className="min-w-0 d-flex flex-column gap-3">
                  <p className="fs--1 fw-medium text-500 mb-0">
                    <span className="d-inline-flex align-items-center gap-1">
                      {card.label}
                      <HelpTooltip html={getHelpHtml(card.helpKey)} />
                    </span>
                  </p>
                  <Flex alignItems="center" className="gap-2 flex-wrap">
                    <p className={`fs-3 fw-bold mb-0 ${card.accent}`}>{card.value}</p>
                    <SubtleBadge bg="secondary" pill className="fs--2 fw-medium" style={{ lineHeight: 1 }}>
                      {card.sub}
                    </SubtleBadge>
                  </Flex>
                </div>
                <IconItem
                  tag="div"
                  icon={card.icon}
                  bg={card.color}
                  color="white"
                  iconClass="fs-0"
                  className="shadow-none flex-shrink-0 align-self-center"
                />
              </Flex>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
